<a
  class="text-blueGray-500 block"
  href="#"
  (click)="toggleDropdown($event)"
  #btnDropdownRef
>
  <div class="items-center flex px-4">
    <span
      class="w-8 h-8 text-lg text-white inline-flex items-center justify-center rounded-full"
    >
        FA

      <img
        alt="..."
        class="w-full rounded-full align-middle border-none p-1"
        src="assets/img/icon/earth.png"
      />
    </span>
  </div>
</a>
<div class=" min-w-140-px z-50" #popoverDropdownRef>
  <div
    class="bg-white text-base z-50 float-left py-2 list-none rounded shadow-lg mt-2 me-4 min-w-140-px"
    [ngClass]="dropdownPopoverShow ? 'block' : 'hidden'"
  >
    <a
      (click)="changeLanguage('ar')"
      class="text-base font-bold py-2 px-4 flex w-full cursor-pointer text-gray-500 hover:bg-primary-light"
    >
    <img class="px-1 w-8" src="../../../assets/img/icon/User_outline.svg" alt="">
      AR
    </a>
    <div class="h-0 my-2 border border-solid border-blueGray-100"></div>
    <a
      (click)="changeLanguage('en')"
      class="text-base py-2 px-4 font-bold flex w-full cursor-pointer text-gray-500 hover:bg-primary-light"
    >
    <img class="px-1 w-8" src="../../../assets/img/icon/Logout_outline.svg" alt="">
    EN 
    </a>
    <a
      (click)="changeLanguage('fa')"
      class="text-base font-bold py-2 px-4 flex w-full cursor-pointer text-gray-500 hover:bg-primary-light"
    >
    <img class="px-1 w-8" src="../../../assets/img/icon/User_outline.svg" alt="">
      FA
    </a>
  </div>
</div>
